var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSumoling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7011 13.5019L1.71478 15.1489C1.4822 15.1486 1.25463 15.0812 1.0594 14.9548C0.864169 14.8284 0.709571 14.6483 0.614162 14.4362C0.518753 14.2241 0.486587 13.9889 0.521524 13.759C0.556461 13.529 0.657018 13.314 0.811123 13.1398C3.56352 10.0062 9.30618 3.19531 14.6326 3.19531C15.7351 3.19506 16.815 3.50848 17.746 4.09897C21.0378 6.16858 20.0163 9.88411 19.0723 11.9569C18.8647 12.4131 18.5314 12.8007 18.1115 13.0744C17.6915 13.348 17.2023 13.4963 16.7011 13.5019Z",
    fill: "#FFBC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6136 1.58752C8.94848 1.58752 3.33962 7.79422 0.190078 11.3908C0.0476245 11.1702 -0.017759 10.9087 0.00414181 10.647C0.0260427 10.3854 0.133994 10.1383 0.311133 9.94453C3.06247 6.80985 8.80831 3.81642e-06 14.1315 3.81642e-06C15.2359 -0.00126164 16.3177 0.312199 17.2503 0.903665C18.1117 1.42555 18.7865 2.20591 19.1786 3.13362C18.9994 2.98853 18.8114 2.85449 18.6159 2.73223C17.4177 1.98154 16.0318 1.58472 14.6179 1.58752",
    fill: "#FFBC00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumoling);
export default __webpack_public_path__ + "static/media/sumoling.eb1b972df5ed196af80c8c5a075ba8ff.svg";
export { ForwardRef as ReactComponent };